import { ApiClient } from '../../client';
import {
  TherapeuticArea,
  CreateTherapeuticAreaRequest,
  UpdateTherapeuticAreaRequest,
  TherapeuticAreaResponse,
  TherapeuticAreaQueryResponse,
  TherapeuticAreaQueryParams,
} from './types';
import { convertDatesToStrings } from '../../../../utils/dateConversion';

export class TherapeuticAreaService {
  constructor(private api: ApiClient) {}

  async getAll(params?: TherapeuticAreaQueryParams) {
    const queryParams = new URLSearchParams();
    if (params?.search) queryParams.append('search', params.search);
    if (params?.advancedSearch)
      queryParams.append(
        'advancedSearch',
        JSON.stringify(params.advancedSearch)
      );
    if (params?.sortBy) queryParams.append('sortBy', params.sortBy);
    if (params?.sortDirection)
      queryParams.append('sortDirection', params.sortDirection);
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.offset) queryParams.append('offset', params.offset.toString());

    const query = queryParams.toString();
    const url = `/therapeutic_areas${query ? `?${query}` : ''}`;
    return this.api.get<TherapeuticAreaQueryResponse>(url);
  }

  async getById(id: number) {
    return this.api.get<TherapeuticArea>(`/therapeutic_areas/${id}`);
  }

  async create(data: CreateTherapeuticAreaRequest) {
    const payload = convertDatesToStrings(data);
    return this.api.post<TherapeuticAreaResponse>(
      '/therapeutic_areas',
      payload
    );
  }

  async update(data: UpdateTherapeuticAreaRequest) {
    const payload = convertDatesToStrings(data);
    return this.api.put<TherapeuticAreaResponse>(
      `/therapeutic_areas/${data.therapeutic_area_id}`,
      payload
    );
  }

  async delete(id: number) {
    return this.api.delete(`/therapeutic_areas/${id}`);
  }
}
